

<template>

    <div :class=" headerClasses " :style="{ bottom : this.topHeaderOpen ? '-25px' : '0px' }">
        <p class="top-header-app-title">Express Orders</p>
        <p class="top-header-merchant-name">{{ currentMerchant.name }}</p>
        <p class="top-header-subtitle">A healthy way to start off your day</p>

        <button v-if=" isAuth " type="button" class="button btn-white" @click=" redirectMenu() ">START ORDER</button>
    </div>

</template>

<script>

    import { mapGetters } from 'vuex';

    export default {

        name: 'top-head',
        computed: {

            ...mapGetters({

                topHeaderOpen   : 'nav/topHeaderOpen',
                isAuth          : 'auth/isAuth',
                currentMerchant : 'merchant/currentMerchant'
            }),
            headerClasses: function(){

                const base = [ 'header-base-class', 'inner-wrap' ];
                return base.join( ' ' );
            }
        },
        methods: {

            redirectMenu(){

                this.$router.push( { name: 'order-menu' } );
            }
        }
    }

</script>

<style scoped>

    .header-base-class {

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;

        position: relative;
        width: 100%;
        height: 175px;
        transition: all 0.7s;
    }
    .inner-wrap {

        padding-left: 15px;
        position: relative;
    }
    .top-header-app-title {

        font-size: 16px;
        padding-bottom: 10px;
        color: rgb(212, 212, 212);
    }
    .top-header-merchant-name {

        font-size: 28px;
        color: rgb(230, 229, 198);
    }

    .top-header-subtitle {

        font-size: 18px;
        width: 200px;
        color: rgb(141, 212, 124);
    }

    button {

        margin: 20px 0px 0px !important;
        border-radius: 15px;
        border: none;
        font-weight: bold;
    }

    .header-open {

        top: 0;
    }
    .header-close {

        top: -175px;
    }
</style>